'use client'

import { cn } from '@/lib/utils'

interface SkipToContentProps {
  className?: string
}

export function SkipToContent({ className }: SkipToContentProps) {
  return (
    <a
      href="#main-content"
      className={cn(
        // Hidden by default, visible on focus
        'absolute top-4 left-4 z-[1000]',
        'bg-primary text-primary-foreground rounded-md px-4 py-2 text-sm font-medium',
        'shadow-lg transition-all duration-200',
        'focus:ring-ring focus:translate-y-0 focus:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-none',
        // Hidden until focused
        '-translate-y-full opacity-0',
        className,
      )}
      onClick={(e) => {
        e.preventDefault()
        const target = document.getElementById('main-content')
        if (target) {
          target.focus()
          target.scrollIntoView({ behavior: 'smooth' })
        }
      }}
    >
      Skip to main content
    </a>
  )
}
